// Shared by the cart panel and legacy recovery page. No automatic cart mutation.
(() => {
  const host=document.querySelector('[data-kb-cart-recovery]');if(!host)return;
  const cartMode=host.dataset.mode==='cart';
  const fragment=location.hash.slice(1);
  if(cartMode&&!fragment.startsWith('kb-recover-'))return;
  host.hidden=false;
  const status=host.querySelector('[data-status]'),list=host.querySelector('[data-items]'),button=host.querySelector('button');
  const token=fragment.replace(/^kb-recover-/,''),endpoint=host.dataset.endpoint;
  const clean=p=>Object.fromEntries(Object.entries(p||{}).filter(([k])=>!['_lead_id','_anon_id','_session_id','Telefon','phone','email','Email','E-mail'].includes(k)).map(([k,v])=>[k,String(v)]).sort(([a],[b])=>a.localeCompare(b)));
  const key=i=>JSON.stringify([String(i.variantId??i.variant_id??i.id),clean(i.properties)]);
  const request=async(url,options={})=>{const r=await fetch(url,{credentials:'same-origin',...options});if(!r.ok)throw Error('request_failed');return r.json();};
  let snapshot=null;
  async function load(){
    if(!/^[a-f0-9]{64}$/.test(token)){status.textContent='Link za sačuvani izbor nije ispravan.';return;}
    try{
      snapshot=await request(endpoint,{method:'POST',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify({token})});
      if(snapshot.version!==1||!Array.isArray(snapshot.items)||!snapshot.items.length||snapshot.items.length>50)throw Error('invalid');
      for(const item of snapshot.items){
        const row=document.createElement('li');
        const title=document.createElement('strong');title.textContent=item.title;row.append(title);
        const details=document.createElement('p');details.textContent=`${item.variantTitle} · Količina: ${item.quantity}`;row.append(details);
        if(item.imageUrl){
          const u=new URL(item.imageUrl);
          const design=u.origin===new URL(endpoint).origin&&['/table_designer/file.php','/cart_recovery/preview.php'].includes(u.pathname)&&item.personalizedPreview===true;
          const catalog=u.origin==='https://cdn.shopify.com'&&u.pathname.startsWith('/s/files/1/0612/4971/6268/')&&item.personalizedPreview===false;
          if(design||catalog){const img=document.createElement('img');img.src=u.href;img.alt=design?'Vaš sačuvani dizajn':'Fotografija modela';img.width=480;img.style.maxWidth='100%';img.style.height='auto';row.prepend(img);}
          if(catalog){const note=document.createElement('p');note.textContent='Fotografija modela — personalizovani dizajn nije sačuvan uz ovu stavku.';row.append(note);}
        }
        list.append(row);
      }
      status.textContent='Proverite svoj izbor. Nastavak dodaje nedostajuće stavke i čuva ostale proizvode u vašoj korpi.';button.disabled=false;
    }catch{status.textContent='Sačuvani izbor trenutno nije dostupan ili je link istekao. Javite nam se da pomognemo.';}
  }
  async function restore(){
    const root=window.Shopify?.routes?.root||'/';
    const current=await request(root+'cart.js');
    const have=new Map(),wanted=new Map();
    for(const i of current.items){const k=key(i);have.set(k,(have.get(k)||0)+i.quantity);}
    for(const i of snapshot.items){const k=key(i);wanted.set(k,{...i,quantity:(wanted.get(k)?.quantity||0)+i.quantity});}
    const additions=[...wanted].filter(([k,i])=>i.quantity>(have.get(k)||0)).map(([k,i])=>({id:i.variantId,quantity:i.quantity-(have.get(k)||0),properties:i.properties}));
    if(additions.length)await request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:additions})});
    const verified=await request(root+'cart.js');const actual=new Map();
    for(const i of verified.items){const k=key(i);actual.set(k,(actual.get(k)||0)+i.quantity);}
    if([...wanted].some(([k,i])=>(actual.get(k)||0)<i.quantity))throw Error('partial');
    location.assign(root+'cart');
  }
  button.addEventListener('click',async()=>{
    if(button.disabled||!snapshot)return;button.disabled=true;status.textContent='Pripremamo vašu korpu…';
    try{
      if(!navigator.locks)throw Error('lock_unavailable');
      await navigator.locks.request('kb-cart-recovery',restore);
    }catch{status.textContent='Nismo mogli da potvrdimo sve stavke. Proverite trenutnu korpu; ponovni pokušaj neće duplirati već dodate proizvode.';button.disabled=false;}
  });
  load();
})();
